<template>
    <div class="type-radio" :class="{disabled: disabled}">
        <label class="option label">
            <input type="radio" :name="name" :value="inputValue" :required="required" :checked="value == inputValue" :data-parsley-required-message="(requiredMessage) ? requiredMessage : false" @change="toggle" :disabled="disabled">
            <span class="option-label"><slot name="radio-label"><span v-html="label"></span></slot></span>
        </label>
    </div>
</template>

<script>
export default {
    
    props: {
        
        disabled: {
            type:       Boolean,
            default:    false,
        },
        
		inputValue: {
			default:	false,
		},
        
		label: {
			type:		String,
		},
        
        name: {
            type:       String,
			required:   true,
        },
        
        required: {
            type:       Boolean,
            default:    false,
        },
        
        requiredMessage: {
            type:       String,
        },
        
		value: {
			default:	false,
			required:   true,
		},
        
    },
    
    data() {
		return {
        };
    },
    
    
    
    methods: {
        toggle(e) {
            this.$emit('input', this.inputValue);
        },
    },
    
};
</script>